<template>
    <div style="height:100%">
        <div id="csContainer">
            <div class="toolbar" >
                <!--    <el-button  size="small" type="primary" @click="addRectangle()" style="padding: 5px">长方体</el-button>-->
                <el-button  size="small" type="primary" @click="addRectangle()"style="padding: 8px; margin: 5px" >建筑物</el-button>

                <br />
                <el-button size="small"  type="primary" @click="addCorridor()" style="padding: 8px; margin: 5px">汽车</el-button>
                <br />
                <el-button  size="small"  type="primary" @click="addCylinders()" style="padding: 8px; margin: 5px">飞机</el-button>
                <br />
                <el-button  size="small"  type="primary" @click="addSphere()" style="padding: 8px; margin: 5px">树木</el-button>
                <br />
                <el-button  size="small"  type="primary" @click="addSphere2()" style="padding: 8px; margin: 5px">人物</el-button>
                <!--      <el-button class="addRectangle"  size="small" type="primary" @click="addRectangle()" >长方体</el-button>-->
                <!--      <el-button class="addCorridor" size="small"  type="primary" @click="addCorridor()" >管道</el-button>-->
                <!--      <el-button class="addCylinders" size="small"  type="primary" @click="addCylinders()" >圆柱、圆锥</el-button>-->
                <!--      <el-button class="addSphere" size="small"  type="primary" @click="addSphere()" >球、椭球</el-button>-->
                <!--      <el-button class="cancel" size="small"  type="info" @click="cancel()" >删除</el-button>-->
            </div>
        </div>
        <div id="loadingOverlay"><h1>Loading........</h1></div>
    </div>
</template>


<script>
    /*eslint-disable*/
    import * as Cesium from "cesium/Cesium";
    import widgets from "cesium/Widgets/widgets.css";
    import util from "../../components/util"
    export default {
        name: 'addGeometry',
        data(){
            return{
                viewer: null            }
        },
        mounted(){
            var loa=document.getElementById('loadingOverlay');
            setTimeout(()=>{
                loa.style.display="none";
            },4000);
            this.init();
        },
        methods:{
            init(){
                // Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiJmZDc4MDllZS01NDZmLTQwNTEtOWYxNy1mZGJhMDVkNjUzOWIiLCJpZCI6MTM0NzksInNjb3BlcyI6WyJhc3IiLCJnYyJdLCJpYXQiOjE1NjMzNTY3MDV9.OGQjCz3Xjb3uNrF89AUmasVwNTFVXFdP6RoqU-q853U';
                Cesium.Ion.defaultAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIzNWZhODgzMC1iNmE5LTQzNWMtOTdiYi00NzAyMzhmZDdmNjgiLCJpZCI6MTg3NTAyLCJpYXQiOjE3MDQyNDkwODl9.81WSf-TbP_6rNXQpVmuQaca_IrKpBje4NKk-BQxt4hg';

                let vm = util.getViewer("csContainer");
                vw.camera.setView({
                    destination : Cesium.Cartesian3.fromDegrees( 104.450625, 31.939831, 5000000.0),
                    orientation : {
                        heading : Cesium.Math.toRadians(-6),
                        pitch : Cesium.Math.toRadians(-85),
                        roll : 0
                    }
                });
                this.viewer = vm;
            },
            addRectangle(){
                let viewer = this.viewer;
                viewer.entities.removeAll();
                viewer.scene.primitives.removeAll();
                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
                let entity = viewer.entities.add({
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: "/demo/static/data/models/dayanta.glb",
                        scale: 2,
                    }
                });

                viewer.zoomTo(entity);
            },
            addCorridor(){
                let viewer = this.viewer;
                viewer.entities.removeAll();
                viewer.scene.primitives.removeAll();
                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
                let entity = viewer.entities.add({
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: "/demo/static/data/models/car.glb",
                        // scale: 0.01,
                    }
                });

                viewer.zoomTo(entity);
            },
            addCylinders(){
                let viewer = this.viewer;
                viewer.entities.removeAll();
                viewer.scene.primitives.removeAll();
                let urlMaterialImg = "img/material/star.jpg";
                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 50);
                let modelMatrix = Cesium.Transforms.headingPitchRollToFixedFrame(position, new Cesium.HeadingPitchRoll(0.0, 0.0, 0.0));
                let scene = viewer.scene;
                let model = viewer.scene.primitives.add(Cesium.Model.fromGltf({

                    // orientation: orientation,

                        url: "/demo/static/data/models/airplane.glb",
                        modelMatrix: modelMatrix,
                        incrementallyLoadTextures: false

                }));

                model.readyPromise.then(function (model) {
                    let camera = viewer.camera;

                    // Zoom to model
                    let controller = scene.screenSpaceCameraController;
                    let r = 2.0 * Math.max(model.boundingSphere.radius, camera.frustum.near);
                    controller.minimumZoomDistance = r * 0.5;

                    let center = Cesium.Matrix4.multiplyByPoint(model.modelMatrix, model.boundingSphere.center, new Cesium.Cartesian3());
                    let heading = Cesium.Math.toRadians(230.0);
                    let pitch = Cesium.Math.toRadians(-20.0);
                    camera.lookAt(center, new Cesium.HeadingPitchRange(heading, pitch, r * 2.0));
                    let textureIndexToReplace = 0;
                    let textures = model._rendererResources.textures;
                    let texture = textures[textureIndexToReplace];
                    Cesium.Resource.fetchImage({
                        url: urlMaterialImg
                    }).then(function (img2) {
                        texture.copyFrom(img2);
                        texture.generateMipmap(); // Also replaces textures in mipmap
                    });
                }).otherwise(function (error) {
                    window.alert(error);
                });
            },
            addSphere(){
                let viewer = this.viewer;
                viewer.entities.removeAll();
                viewer.scene.primitives.removeAll();
                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
                let entity = viewer.entities.add({
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: "/demo/static/data/models/smalltree22.glb",
                        scale: 1,
                    }
                });

                viewer.zoomTo(entity);
            },
            addSphere2(){
                let viewer = this.viewer;
                viewer.entities.removeAll();
                viewer.scene.primitives.removeAll();
                let position = Cesium.Cartesian3.fromDegrees(-123.0744619, 44.0503706, 0);
                let heading = Cesium.Math.toRadians(135);
                let pitch = 0;
                let roll = 0;
                let hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
                let orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
                let entity = viewer.entities.add({
                    position: position,
                    orientation: orientation,
                    model: {
                        uri: "/demo/static/data/models/people.glb",
                        scale: 0.01,
                    }
                });

                viewer.zoomTo(entity);
            },
            cancel(){
                let viewer = this.viewer;
                viewer.dataSources.removeAll();
            }


        }
    }
</script>
<style scoped>
    .addRectangle {
        position: absolute;
        margin-left: 20px;
        margin-top:7px;
        z-index: 999;
    }
    .addCorridor {
        position: absolute;
        margin-left: 110px;
        margin-top:7px;
        z-index: 999;
    }
    .addCylinders{
        position: absolute;
        margin-left: 185px;
        margin-top:7px;
        z-index: 999;
    }
    .addSphere{
        position: absolute;
        margin-left: 295px;
        margin-top:7px;
        z-index: 999;
    }
    .cancel{
        position: absolute;
        margin-left: 395px;
        margin-top:7px;
        z-index: 999;
    }
    #csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
</style>
